module.exports = __webpack_public_path__ + "img/namsan_gallery4.fbe1945d.jpg";